import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectSpread from "@babel/runtime/helpers/objectSpread";

var _reducerMap;

import { handleActions } from 'redux-actions';
import actions from '../actions/app';
export var name = 'app'; // as far as the server is concerned, the app is always online

var isServer = !globalThis.navigator;
var isOnline = !isServer && navigator.onLine;
var hasBeenOffline = !isServer && !navigator.onLine;
var initialState = {
  drawer: null,
  hasBeenOffline: hasBeenOffline,
  isOnline: isOnline,
  isPageLoading: false,
  overlay: false,
  pending: {},
  searchOpen: false,
  nextRootComponent: null
};
var reducerMap = (_reducerMap = {}, _defineProperty(_reducerMap, actions.toggleDrawer, function (state, _ref) {
  var payload = _ref.payload;
  return _objectSpread({}, state, {
    drawer: payload,
    overlay: !!payload
  });
}), _defineProperty(_reducerMap, actions.toggleSearch, function (state) {
  return _objectSpread({}, state, {
    searchOpen: !state.searchOpen
  });
}), _defineProperty(_reducerMap, actions.setOnline, function (state) {
  return _objectSpread({}, state, {
    isOnline: true
  });
}), _defineProperty(_reducerMap, actions.setOffline, function (state) {
  return _objectSpread({}, state, {
    isOnline: false,
    hasBeenOffline: true
  });
}), _defineProperty(_reducerMap, actions.setPageLoading, function (state, _ref2) {
  var payload = _ref2.payload;
  return _objectSpread({}, state, {
    isPageLoading: !!payload
  });
}), _defineProperty(_reducerMap, actions.setNextRootComponent, function (state, _ref3) {
  var payload = _ref3.payload;
  return _objectSpread({}, state, {
    nextRootComponent: payload
  });
}), _reducerMap);
export default handleActions(reducerMap, initialState);